module.exports = __webpack_public_path__ + "img/acOfflineFlow.80ce33b3.jpg";